<div class="modal-content">
    <div class="modal-header">
        <h2 class="modal-title" id="modal-title">{{ header }}</h2>
    </div>

    <div class="modal-body">
        {{ message }}
    </div>

    <div class="modal-footer">
        <rask-button
            color="secondary"
            (click)="setResponse(false)">
            Avbryt
        </rask-button>

        <rask-button
            color="primary"
            (click)="setResponse(true)">
            Ok
        </rask-button>
    </div>
</div>